<div
  class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
>
  <h4
    class="gw-text-xl gw-font-semibold gw-text-text-primary"
    id="modal-basic-title"
  >
    {{ 'features.integrations.configureCredentials' | translate }}
  </h4>
</div>
<div class="gw-p-6">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="gw-space-y-4">
    <div class="gw-mb-4">
      <label
        for="pagare-accountId"
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
      >
        {{ 'features.integrations.accountId' | translate }}
      </label>
      <input
        id="pagare-accountId"
        type="text"
        class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
        formControlName="accountId"
        [placeholder]="'features.integrations.accountIdPlaceholder' | translate"
        autocomplete="off"
      />
      <small
        *ngIf="form.get('accountId')?.invalid && form.get('accountId')?.touched"
        class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
      >
        {{ 'features.integrations.accountIdRequired' | translate }}
      </small>
    </div>

    <div class="gw-mb-4 gw-flex gw-items-center gw-gap-2">
      <input
        type="checkbox"
        class="gw-w-4 gw-h-4 gw-rounded gw-border-border-normal"
        formControlName="advanced"
        id="pagare-advanced"
      />
      <label
        for="pagare-advanced"
        class="gw-text-sm gw-font-medium gw-text-text-primary"
      >
        {{ 'features.integrations.advancedConfiguration' | translate }}
      </label>
    </div>

    <div *ngIf="form.get('advanced')?.value" class="gw-space-y-4">
      <div class="gw-mb-4 gw-flex gw-items-center gw-gap-2">
        <input
          type="checkbox"
          class="gw-w-4 gw-h-4 gw-rounded gw-border-border-normal"
          formControlName="sandbox"
          id="pagare-sandbox"
        />
        <label
          for="pagare-sandbox"
          class="gw-text-sm gw-font-medium gw-text-text-primary"
        >
          {{ 'features.integrations.sandboxMode' | translate }}
        </label>
      </div>

      <div class="gw-mb-4">
        <label
          for="pagare-tenantKey"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.tenantKey' | translate }}
        </label>
        <input
          id="pagare-tenantKey"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="tenantKey"
          [placeholder]="
            'features.integrations.tenantKeyPlaceholder' | translate
          "
          autocomplete="off"
        />
        <small
          *ngIf="
            form.get('tenantKey')?.invalid && form.get('tenantKey')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.tenantKeyRequired' | translate }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="pagare-username"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.username' | translate }}
        </label>
        <input
          id="pagare-username"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="username"
          [placeholder]="
            'features.integrations.usernamePlaceholder' | translate
          "
          autocomplete="off"
        />
        <small
          *ngIf="form.get('username')?.invalid && form.get('username')?.touched"
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.usernameRequired' | translate }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="pagare-password"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.password' | translate }}
        </label>
        <input
          id="pagare-password"
          type="password"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="password"
          [placeholder]="
            'features.integrations.passwordPlaceholder' | translate
          "
          autocomplete="off"
        />
        <small
          *ngIf="form.get('password')?.invalid && form.get('password')?.touched"
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.passwordRequired' | translate }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="pagare-signingSecret"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.signingSecret' | translate }}
        </label>
        <input
          id="pagare-signingSecret"
          type="password"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="signingSecret"
          [placeholder]="
            'features.integrations.signingSecretPlaceholder' | translate
          "
          autocomplete="off"
        />
      </div>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        [title]="'common.actions.cancel' | translate"
        variant="secondary"
        type="button"
        (click)="close()"
      ></gatewee-button>
      <gatewee-button
        [title]="
          submitting
            ? ('common.actions.saving' | translate)
            : ('common.actions.save' | translate)
        "
        variant="primary"
        type="submit"
        [disabled]="form.invalid || submitting"
      ></gatewee-button>
    </div>
  </form>
</div>
